import VueRouter from 'vue-router'
import Vue from 'vue'
import store from '../store'
import * as api from '../api/api'

Vue.use(VueRouter);
/*登录页面*/
const login = () => import("@/page/login/login");
/*设置部分*/
// const systemInfo = () => import("@/page/settings/system");
const AppUpgrade = () => import("@/page/settings/AppUpgrade");
const Feedback = () => import("@/page/settings/Feedback");
/*布局*/
const baseView = () => import("@/layout/base-view");
const rightView = () => import("@/layout/right-content");
const index = () => import("@/page/dashboard/index");
/*套餐管理*/
const packageConfig = () => import("@/page/package/package-config.vue");
const appModule = () => import("@/page/settings/AppModule.vue");
// const packageOrder = () => import("@/page/package/package-order.vue");
/*睡前故事*/
const sleepCategory = () => import("@/page/sleep/category");
const sleepStory = () => import("@/page/sleep/story");
/*识字*/
const wordBook = () => import("@/page/word/book");
const bookDetail = () => import("@/page/word/book-detail");
const wordList = () => import("@/page/word/word");
const reading = () => import("@/page/word/reading");
const readingDetail = () => import("@/page/word/reading-detail");
const readingQa = () => import("@/page/word/reading-qa");
const game = () => import("@/page/word/game");
const gameConfig = () => import("@/page/word/game-config");


export const routes = [
    {
        path: '',
        component: baseView,
        redirect: '/index',
        children: [
            {
                path: "/index",
                name: '首页',
                icon: 'el-icon-s-home',
                hidden: false,
                component: index
            },
            {
                path: '/sleep',
                name: '睡前故事',
                hidden: false,
                icon: 'el-icon-setting',
                component: rightView,
                children: [
                    {
                        path: 'category',
                        hidden: false,
                        name: '故事分类',
                        icon: 'el-icon-cpu',
                        component: sleepCategory,
                    }, {
                        path: 'story',
                        hidden: false,
                        name: '故事管理',
                        icon: 'el-icon-cpu',
                        component: sleepStory,
                    }
                ]
            },
            {
                path: '/word',
                name: '超田识字',
                hidden: false,
                icon: 'el-icon-setting',
                component: rightView,
                children: [
                    {
                        path: 'book',
                        hidden: false,
                        name: '教材管理',
                        icon: 'el-icon-cpu',
                        component: wordBook,
                    }, {
                        path: 'book-detail',
                        hidden: true,
                        showBack: true,
                        name: '教材详情',
                        icon: 'el-icon-cpu',
                        component: bookDetail,
                    }, {
                        path: 'word',
                        hidden: false,
                        name: '识字管理',
                        icon: 'el-icon-cpu',
                        component: wordList,
                    }, {
                        path: 'reading',
                        hidden: false,
                        name: '读本管理',
                        icon: 'el-icon-cpu',
                        component: reading,
                    }, {
                        path: 'reading-detail',
                        hidden: true,
                        name: '读本详情',
                        icon: 'el-icon-cpu',
                        component: readingDetail,
                    }, {
                        path: 'reading-qa',
                        hidden: true,
                        name: '读本游戏',
                        icon: 'el-icon-cpu',
                        component: readingQa,
                    }, {
                        path: 'game',
                        hidden: false,
                        name: '游戏管理',
                        icon: 'el-icon-cpu',
                        component: game,
                    }, {
                        path: 'game-config',
                        hidden: true,
                        name: '游戏配置',
                        icon: 'el-icon-cpu',
                        component: gameConfig,
                    },
                ]
            },
            {
                path: '/package',
                name: '套餐管理',
                hidden: false,
                icon: 'el-icon-setting',
                component: rightView,
                children: [
                    {
                        path: 'package',
                        hidden: false,
                        name: '套餐配置',
                        icon: 'el-icon-cpu',
                        component: packageConfig,
                    }
                    // , {
                    //     path: 'order',
                    //     hidden: false,
                    //     name: '用户订单',
                    //     icon: 'el-icon-cpu',
                    //     component: packageOrder,
                    // }
                ]
            },
            {
                path: '/settings',
                name: '设置',
                hidden: false,
                icon: 'el-icon-setting',
                component: rightView,
                children: [
                    // {
                    //     path: 'sys-info',
                    //     hidden: false,
                    //     name: '系统信息',
                    //     icon: 'el-icon-cpu',
                    //     component: systemInfo,
                    // },
                    {
                        path: 'appModule',
                        hidden: false,
                        name: '模块配置',
                        icon: 'el-icon-cpu',
                        component: appModule,
                    },
                    {
                        path: 'app-upgrade',
                        hidden: false,
                        name: 'APP升级',
                        icon: 'el-icon-cpu',
                        component: AppUpgrade,
                    },
                    {
                        path: 'feedback',
                        hidden: false,
                        name: '反馈建议',
                        icon: 'el-icon-cpu',
                        component: Feedback,
                    }
                ]
            }
        ]
    },
    {
        path: '/login',
        component: login
    }
];


const router = new VueRouter({
    routes // (缩写) 相当于 routes: routes
});

router.beforeEach((to, from, next) => {
    const token = store.state.user.token;

    // 处理登录页面的访问
    if (to.path === '/login') {
        if (token && Object.keys(store.state.user.userInfo).length > 0) {
            // 已登录且有用户信息，跳转到首页
            next('/');
        } else {
            // 未登录或无用户信息，允许访问登录页
            next();
        }
        return;
    }

    // 处理非登录页面的访问
    if (!token) {
        next('/login');
        return;
    }

    // 已登录且有用户信息
    if (Object.keys(store.state.user.userInfo).length > 0) {
        next();
        return;
    }

    // 已登录但没有用户信息，获取用户信息
    api.checkToken()
        .then(result => {
            if (result.code === api.LOGIN_SUCCESS) {
                const userInfo = {
                    avatar: result.data.avatar,
                    roleId: result.data.roleId,
                    userName: result.data.userName,
                    userId: result.data.id,
                    companyId: result.data.companyId,
                    companyName: result.data.companyName
                };
                store.dispatch('setUserInfo', userInfo);
                next();
            } else {
                store.dispatch('logout');
                next('/login');
            }
        })
        .catch(() => {
            store.dispatch('logout');
            next('/login');
        });
});

export default router;
